import {prependToLimited} from 'utils/array';

const GET_PROFILE_REQUEST = 'GET_PROFILE_REQUEST';
const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS';
const GET_PROFILE_FAILURE = 'GET_PROFILE_FAILURE';

const GET_MEMBER_PHOTO_REQUEST = 'GET_MEMBER_PHOTO_REQUEST';
const GET_MEMBER_PHOTO_SUCCESS = 'GET_MEMBER_PHOTO_SUCCESS';
const GET_MEMBER_PHOTO_FAILURE = 'GET_MEMBER_PHOTO_FAILURE';
const CLOSE_MEMBER_PHOTO = 'CLOSE_MEMBER_PHOTO';

const PROFILE_DENOUNCED = 'PROFILE_DENOUNCED';
const PROFILE_BLACKLISTED = 'PROFILE_BLACKLISTED';
const PROFILE_UNBLACKLISTED = 'PROFILE_UNBLACKLISTED';

import {
    MEMBER_FOLLOW_PROFILE_SUCCESS,
    MEMBER_UNFOLLOW_PROFILE_SUCCESS,
    MEMBER_GUESTBOOK_DELETE_MESSAGE_SUCCESS,
    MEMBER_GUESTBOOK_MESSAGE_ADDED
} from './member';

import {WALL_MATERIAL_LIKE_SUCCESS} from 'reducers/wallMaterial';

import {GUESTBOOK_MESSAGES_PER_PAGE} from '../constants/profile';

import * as backend from 'backend-helpers/profile';
import {BobTVUser} from 'bobtvuser';

const initState = {
    user: undefined,
    stats: {},
    online: null,
    followedByMe: null,
    blacklistedByMe: null,
    blacklistedMe: null,
    denounced: null,
    certifiedMemberPhotos: [],
    memberPhotos: {
        list: [],
        totalCount: 0
    },
    amateurFilms: {
        list: [],
        totalCount: 0
    },
    wallMaterials: {
        list: [],
        totalCount: 0
    },
    virtualGifts: {
        list: [],
        totalCount: 0
    },
    wishlist: {
        list: [],
        totalCount: 0
    },
    guestbookMessages: {
        list: [],
        totalCount: 0
    }
};

export default function profile(state = initState, action) {
    if (action.type === GET_PROFILE_SUCCESS) {
        let {status, user, ...rest} = action.result;

        return {
            ...state,
            ...rest,
            user: new BobTVUser(user)
        }
    }

    if (action.type === GET_PROFILE_FAILURE) {
        let {error, ...rest} = action;

        console.log('GET_PROFILE_FAILURE:', error);

        return {
            ...state,
            user: new BobTVUser({_loaded: false, _notFound: true})
        }
    }

    if (action.type === MEMBER_GUESTBOOK_MESSAGE_ADDED && state.user && action.user.id === state.user.id) {
        return {
            ...state,
            guestbookMessages: {
                list: prependToLimited(state.guestbookMessages.list, action.guestbookMessage, GUESTBOOK_MESSAGES_PER_PAGE),
                totalCount: state.guestbookMessages.totalCount+1
            }
        }
    }

    if (action.type === MEMBER_GUESTBOOK_DELETE_MESSAGE_SUCCESS) {
        let guestbookMessagesList = state.guestbookMessages.list.filter((item) => item.id !== action.id),
            profileGuestbookChanged = (state.guestbookMessages.list.length > 0 && guestbookMessagesList.length != state.guestbookMessages.list.length);

        if (profileGuestbookChanged) {
            return {
                ...state,
                guestbookMessages: {
                    list: guestbookMessagesList,
                    totalCount: state.guestbookMessages.totalCount-1
                }
            }
        }
    }

    if (action.type === MEMBER_FOLLOW_PROFILE_SUCCESS && state.user && state.user.id === action.id) {
        return {
            ...state,
            followedByMe: true,
            stats: {
                ...state.stats,
                followerCount: state.stats.followerCount + 1
            }
        }
    }

    if (action.type === MEMBER_UNFOLLOW_PROFILE_SUCCESS && state.user && state.user.id === action.id) {
        return {
            ...state,
            followedByMe: false,
            stats: {
                ...state.stats,
                followerCount: state.stats.followerCount - 1
            }
        }
    }

    if (action.type === PROFILE_DENOUNCED && state.user && state.user.nick == action.nick) {
        return {
            ...state,
            denounced: true
        }
    }

    if (action.type === PROFILE_BLACKLISTED && state.user && state.user.id == action.id) {
        return {
            ...state,
            blacklistedByMe: true
        }
    }

    if (action.type === PROFILE_UNBLACKLISTED && state.user && state.user.id == action.id) {
        return {
            ...state,
            blacklistedByMe: false
        }
    }

    if (action.type === WALL_MATERIAL_LIKE_SUCCESS) {
        let {like_count} = action.result;

        return {
            ...state,
            wallMaterials: {
                ...state.wallMaterials,
                list: state.wallMaterials.list.map((wallMaterial) => action.id === wallMaterial.id ? {...wallMaterial, like_count} : wallMaterial)
            }
        }

    }

    return state;
}

export function getProfile(nick) {
    return {
        types: [GET_PROFILE_REQUEST, GET_PROFILE_SUCCESS, GET_PROFILE_FAILURE],
        promise: backend.getProfile({nick})
    }
}

export function profileDenounced(nick) {
    return {
        type: PROFILE_DENOUNCED,
        nick
    }
}

export function profileBlacklisted(id) {
    return {
        type: PROFILE_BLACKLISTED,
        id
    }
}

export function profileUnblacklisted(id) {
    return {
        type: PROFILE_UNBLACKLISTED,
        id
    }
}


// WEBPACK FOOTER //
// ./src/reducers/profile.js